import { useEffect , useState } from 'react'

import { priceFormat } from 'util/prices'
import { repareImage } from 'newFunctions/repareDataService'
import { BASE_PATH_API, NO_IMAGE_DEFAULT } from 'constants/env'
import { DOMAIN_CMS } from 'constants/general'
import styles from '../styles.module.sass'

const OnlyStore = (props) => {

    const {
        producto,
        typeCard = 'myAccount'
    } = props

    const Domain = BASE_PATH_API

    const [ notProduct, setNotProduct ] = useState(false)
    const [ responseProduct, setResponseProducts ] = useState(null)
    const [ respProduct, setRespProduct ] = useState(false)

    // validate product exist
    const validateProductGet = async (skuProduct) => {
        try{
            const response = await fetch(`${Domain}/products/v1/products?filter_by[sku]=${skuProduct}&filter_by[seller_id]=2430`);
            const data = await response.json();
            if(data?.data?.length >= 1){
                setResponseProducts(data?.data)
            }else{
                setNotProduct(true)
            }
        } catch (error) {
            console.error('Error fetching cmsProductGet data:', error);
        }
    }

    // validate product in CMS
    const cmsProductGet = async (skuProduct) => {
        const config = {
            method: 'GET',
            redirect: 'follow',
            withCredentials: true,
            timeout: 25,
        }
        try{
            const response = await fetch( `${DOMAIN_CMS}/api-productos/?sku=${skuProduct}`, config )
            const data = await response.json();
            setRespProduct(data)
            // console.log('data cmsProductGet: ',data)
        } catch (error) {
            console.error('Error fetching cmsProductGet data:', error);
        }
    }

    useEffect(()=>{
        if(producto?.sku){
            validateProductGet(producto?.sku)
        }
    },[ producto?.sku ])

    useEffect(()=>{
        if(responseProduct){
            console.log('responseProduct: ',responseProduct)


        }
    },[ responseProduct ])

    useEffect(()=>{
        if(notProduct){
            if(producto?.sku){
                cmsProductGet(producto?.sku)
            }
        }
    },[ producto?.sku, notProduct ])

    useEffect(()=>{},[ respProduct ])

    return(
        respProduct
            ?
                !respProduct?.error
                    ?
                        typeCard === 'myAccount'
                            ?
                                <article className={`${styles?.cardProduct} ${styles?.cardStore}`} data-type={producto?.sku}> 
                                    <div className={styles?.soldOut}>Solo disponible en tienda</div>
                                    <div className={styles?.imgStore} />
                                    <div className={styles?.contProductInt}>
                                        <p className={styles?.title}>{respProduct?.nombre_producto ? respProduct?.nombre_producto : `SKU: ${producto?.sku}`}</p>
                                        <div className={styles?.contPrices}>
                                            <p className={styles?.salesPrice}>${priceFormat(respProduct?.precio_lista)} MXN</p>
                                        </div>
                                    </div>
                                    <div><p>SKU: {producto?.sku}</p></div>
                                    <div className={styles?.totalStock}>
                                        <span>0</span> de <span>1</span>
                                    </div>
                                </article>
                            :
                                typeCard === 'userView'
                                    ?
                                        <article className={`${styles?.cardProduct} ${styles?.cardGifts} ${styles?.cardStore}`} data-type={producto?.sku}> 
                                            <div className={styles?.soldOut} />
                                            <img 
                                                src={repareImage(NO_IMAGE_DEFAULT)} 
                                                alt={respProduct?.nombre_producto} 
                                                className={styles?.imageProduct} 
                                            />
                                            <div className={styles?.contProductInt}>
                                                <p className={styles?.title}>{respProduct?.nombre_producto}</p>
                                                <p className={styles?.bold}>{`SKU: ${producto?.sku}`}</p>
                                                <div className={styles?.contPrices}>
                                                    <p className={styles?.salesPrice}>${priceFormat(respProduct?.precio_lista)} MXN</p>
                                                </div>
                                                {/* <p>SKU: {producto?.sku}</p> */}
                                                <p className={styles?.storeOnly}>Solo disponible en tienda</p>
                                                <p className={styles?.amount}>Cantidad: 1</p>
                                            </div>
                                        </article>
                                    : null
                    : null
            : null
    )
}

export default OnlyStore
